module.exports = __webpack_public_path__ + "media/images/companies/daishi_bank-c65b4b96355f8b9b345c546dc9cd2578.jpg";